import axios from "axios";

const instance = axios.create({
  baseURL: window.location.origin + "/api",
  headers: {
    "Content-Type": "application/json, text/plain, */*",
    "Accepts":"application/json"
  }
});

instance.interceptors.response.use(
  function (response) { return response; },
  function (error) {
    // handle error
    return Promise.reject(error);
  });

export default instance;